import React, { useEffect, useState, useContext } from 'react'
import { CCol, CWidgetDropdown, CSpinner } from '@coreui/react'
import { getStyle } from '@coreui/utils'
import { CChartLine } from '@coreui/react-chartjs'
import CIcon from '@coreui/icons-react'
import { cilArrowBottom, cilArrowTop, cilOptions } from '@coreui/icons'
import getSymbolFromCurrency from 'currency-symbol-map'
import { Dropdown } from 'react-bootstrap'
import { isEmpty } from 'lodash'
import useAxios from 'axios-hooks'
import { ANALYTICS_API } from 'src/views/utils/urls'
import { AppContext } from '../context/app'

const RevenueCard = ({ getDateLabels }) => {
  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [currencyData, setCurrencyData] = useState([])
  const { accountObj } = useContext(AppContext)

  const [{ data: revenueData }, revenueCardCall] = useAxios(
    {
      url: `${ANALYTICS_API}/revenue-card`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    if (!isEmpty(accountObj)) {
      setSelectedCurrency(accountObj?.allowed_countries[0]?.currency)
      getSymbolFromCurrency(accountObj?.allowed_countries[0]?.currency)
      setCurrencyData(accountObj?.allowed_countries)
      getRevenueCardData(accountObj?.allowed_countries[0]?.currency)
    }
  }, [accountObj])

  const getRevenueCardData = async (currency) => {
    await revenueCardCall({
      params: {
        delta_window: 90,
        unit_window: 7,
        num_data_points: 9,
        currency: currency,
      },
    })
  }

  const handleCurrencyChange = async (currency) => {
    await revenueCardCall({
      params: {
        delta_window: 90,
        unit_window: 7,
        num_data_points: 9,
        currency: currency,
      },
    })
    setSelectedCurrency(currency)
  }

  const getTotalRevenueText = (total) => {
    let symbol = getSymbolFromCurrency(selectedCurrency)

    return (
      <div className="d-flex justify-content-center align-items-center">
        {symbol + ' ' + total}&nbsp;
        <div className="fs-6 fw-normal">
          ({Number(revenueData?.data?.percentage_delta).toFixed(1)}
          {revenueData?.data?.percentage_delta > 0 ? (
            <CIcon icon={cilArrowTop} />
          ) : (
            <CIcon icon={cilArrowBottom} />
          )}
          )
        </div>
      </div>
    )
  }
  return (
    <CCol sm={6} lg={3}>
      <CWidgetDropdown
        className="mb-4"
        color="info"
        value={
          revenueData?.data ? (
            getTotalRevenueText(Number(revenueData?.data?.revenue).toFixed(2))
          ) : (
            <CSpinner color="light" />
          )
        }
        title="Revenue"
        action={
          <Dropdown align="end" className="">
            <Dropdown.Toggle variant="transparent" className="p-0" id="revenue-dropdown">
              <CIcon icon={cilOptions} className="text-high-emphasis-inverse" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item disabled>Select Currency</Dropdown.Item>
              {currencyData &&
                currencyData.map((info, index) => (
                  <Dropdown.Item
                    style={{ cursor: 'pointer' }}
                    key={index}
                    onClick={() => handleCurrencyChange(info.currency)}
                  >
                    {info.currency}({getSymbolFromCurrency(info.currency)})
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        }
        chart={
          <CChartLine
            className="mt-3 mx-3 pb-1"
            style={{ height: '70px' }}
            data={{
              labels: getDateLabels(1, 9),
              datasets: [
                {
                  label: 'Total Revenue',
                  backgroundColor: 'rgba(255,255,255,.2)',
                  borderColor: 'rgba(255,255,255,.55)',
                  pointBackgroundColor: getStyle('--cui-info'),
                  data: revenueData?.data?.data_points,
                  fill: true,
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
              maintainAspectRatio: false,
              scales: {
                x: {
                  display: false,
                },
                y: {
                  display: false,
                },
              },
              elements: {
                line: {
                  borderWidth: 1,
                  tension: 0.4,
                },
                point: {
                  radius: 4,
                  hitRadius: 10,
                  hoverRadius: 4,
                },
              },
            }}
          />
        }
      />
    </CCol>
  )
}

export default RevenueCard
